import { Typography } from '@mui/material';
import { ODSCheckmark } from '@telekom-ods/react-icons';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Modal from '.';

interface SuccessModalProps {
  messageId: string;
  title: string;
  onSubmit: () => void;
  onClose: () => void;
}

const SuccessModal = ({ messageId, title, onSubmit, onClose }: SuccessModalProps) => {
  const intl = useIntl();

  return (
    <Modal
      hideActions
      title={title}
      onSubmit={onSubmit}
      onClose={onClose}
      submitLabel={intl.formatMessage({ id: 'okay' })}
    >
      <ODSCheckmark
        style={{
          fontSize: '7rem',
          color: 'limegreen',
          display: 'flex',
          margin: 'auto',
        }}
      />
      <Typography>{intl.formatMessage({ id: messageId })}</Typography>
    </Modal>
  );
};

SuccessModal.propTypes = {
  messageId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SuccessModal;
